/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const alignCenter = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M7.5 5.5h9V4h-9v1.5Zm-3.5 7h16V11H4v1.5Zm3.5 7h9V18h-9v1.5Z" />
	</SVG>
);

export default alignCenter;
